// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { User, Lock, Layout, ChevronRight, AlertCircle } from "lucide-react";
// import { Api } from "../Api/Api";


// export default function LoginPage() {
//   const navigate = useNavigate();
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);


  
//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     try {
//       // const res = await fetch("http://localhost/erp/api/login.php", {
//       const res = await fetch(`${Api}api/login.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ username, password }),
//       });

//       const data = await res.json();

//       if (!data.status) {
//         setError(data.message);
//         setLoading(false);
//         return;
//       }

//       localStorage.setItem("currentUser", JSON.stringify(data.user));
//       // Change this line to ensure you see what's being saved
//       console.log("User Data from Server:", data.user);
//       // localStorage.setItem("currentUser", JSON.stringify(data.user));

//       // ✅ Role-based redirect
//       if (data.user.role === "admin") {
//         navigate("/admin/dashboard1");
//       } else {
//         navigate("/staff/dashboard2");
//       }
//     } catch (err) {
//       setError("Server error. Check PHP backend.");
//     }

//     setLoading(false);
//   };

//   return (
//     <div className="flex h-screen w-full bg-white font-sans text-slate-900 overflow-hidden">
//       {/* LEFT SIDE: Matching the dark theme and dot pattern */}
//       <div className="hidden lg:flex lg:w-1/2 bg-[#050b18] p-16 flex-col justify-between text-white relative">
//         {/* Exact Dot Pattern from screenshot */}
//         <div
//           className="absolute inset-0 pointer-events-none opacity-20"
//           style={{
//             backgroundImage: "radial-gradient(#4b5563 1px, transparent 0)",
//             backgroundSize: "32px 32px",
//           }}
//         ></div>

//         <div className="relative z-10">
//           <div className="flex items-center gap-3 mb-16">
//             <div className="w-10 h-10 bg-[#1d63ed] rounded-lg flex items-center justify-center shadow-lg shadow-blue-500/20">
//               <span className="text-white font-bold text-xl">E</span>
//             </div>
//             <span className="text-xl font-bold tracking-tight uppercase">
//               ERP Core
//             </span>
//           </div>

//           <h2 className="text-5xl font-bold leading-tight mb-6">
//             Manage your enterprise <br />
//             <span className="text-[#3b82f6]">with precision.</span>
//           </h2>

//           <p className="text-slate-400 text-lg max-w-sm leading-relaxed mt-4">
//             The integrated platform for financial management, customer
//             relations, and real-time business intelligence.
//           </p>
//         </div>

//         <div className="relative z-10 opacity-60">
//           <div className="w-full border-t border-slate-800 mb-6"></div>
//           <p className="text-sm text-slate-500 italic">
//             "Efficiency is doing things right; effectiveness is doing the right
//             things."
//           </p>
//         </div>
//       </div>

//       {/* RIGHT SIDE: Matching the form density and colors */}
//       <div className="w-full lg:w-1/2 flex flex-col items-center justify-center p-8 bg-white overflow-hidden">
//         <div className="w-full max-w-[400px]">
//           <header className="mb-8">
//             <h3 className="text-3xl font-bold text-slate-900 tracking-tight mb-2">
//               Sign In
//             </h3>
//             <p className="text-slate-500 text-sm">
//               Welcome back. Please enter your credentials to access the portal.
//             </p>
//           </header>

//           {error && (
//             <div className="mb-6 flex items-start gap-3 bg-red-50 border-l-4 border-red-500 p-3 text-red-800 text-xs rounded">
//               <AlertCircle className="w-4 h-4 mt-0.5 text-red-600" />
//               <p className="font-semibold">{error}</p>
//             </div>
//           )}

//           <form onSubmit={handleLogin} className="space-y-5">
//             <div className="space-y-1.5">
//               <label className="text-[13px] font-semibold text-slate-700 flex items-center gap-2">
//                 <User size={14} className="text-slate-400" /> Username
//               </label>
//               <input
//                 type="text"
//                 placeholder="e.g. jdoe_admin"
//                 className="w-full h-11 px-4 rounded-lg border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-[#1d63ed] outline-none transition-all placeholder:text-slate-300 text-sm"
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//                 required
//               />
//             </div>

//             <div className="space-y-1.5">
//               <label className="text-[13px] font-semibold text-slate-700 flex items-center gap-2">
//                 <Lock size={14} className="text-slate-400" /> Password
//               </label>
//               <input
//                 type="password"
//                 placeholder="••••••••"
//                 className="w-full h-11 px-4 rounded-lg border border-slate-200 bg-[#fcfcfd] focus:ring-2 focus:ring-blue-500/20 focus:border-[#1d63ed] outline-none transition-all placeholder:text-slate-300 text-sm"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full h-12 bg-[#1d63ed] hover:bg-blue-700 text-white rounded-lg flex items-center justify-center gap-2 font-bold text-sm shadow-md transition-all active:scale-[0.99] mt-2"
//             >
//               {loading ? "Verifying..." : "Access System"}
//               <ChevronRight size={16} />
//             </button>
//           </form>

//           {/* Institutional Credentials Box - Styled exactly like screenshot */}
//           <div className="mt-12 text-center">
          

         
//             <div className="space-y-6">
//               <button
//                 type="button"
//                 className="text-sm font-bold text-[#1d63ed] hover:underline"
//               >
//                 Register New Admin Account
//               </button>

//               <p className="text-[10px] text-slate-300 uppercase tracking-widest block pt-4">
//                 &copy; 2026 ERP Systems International. All Rights Reserved.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { User, Lock, ChevronRight, AlertCircle } from "lucide-react";
import { Api } from "../Api/Api";
import logo from "./logo.png";


export default function LoginPage() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ BLOCK LOGIN PAGE IF ALREADY LOGGED IN
  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));

    if (currentUser) {
      if (currentUser.role === "admin") {
        navigate("/admin/dashboard1", { replace: true });
      } else {
        navigate("/staff/dashboard2", { replace: true });
      }
    }
  }, [navigate]);



  const handleLogin = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
    // 1️⃣ Try normal login
    let res = await fetch(`${Api}api/login.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });

    let data = await res.json();

    // 2️⃣ If normal login fails → try admin login
    if (!data.status) {
      res = await fetch(`${Api}admin/login.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      data = await res.json();
    }

    // 3️⃣ If still failed
    if (!data.status) {
      setError(data.message || "Invalid credentials");
      setLoading(false);
      return;
    }

    // 4️⃣ Save user
    localStorage.setItem("currentUser", JSON.stringify(data.user));

    // 5️⃣ Role-based redirect
    if (data.user.role === "admin") {
      navigate("/admin/dashboard1", { replace: true });
    } else {
      navigate("/staff/dashboard2", { replace: true });
    }
  } catch (err) {
    setError("Server error. Please try again.");
  }

  setLoading(false);
};


  return (
    <div className="flex h-screen w-full bg-white font-sans text-slate-900 overflow-hidden">
      {/* LEFT PANEL */}
      <div className="hidden lg:flex lg:w-1/2 bg-[#050b18] p-16 flex-col justify-between text-white relative">
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: "radial-gradient(#4b5563 1px, transparent 0)",
            backgroundSize: "32px 32px",
          }}
        />

        <div className="relative z-10">
         

          <div className="flex items-center gap-4 mb-16">
            <img
              src={logo}
              alt="SAL Finance Logo"
              className="w-20 h-20 object-contain"
            />
            <span className="text-3xl font-extrabold tracking-wide">
              SAL FINANCE
            </span>
          </div>

          <h2 className="text-5xl font-bold mb-6">
            Manage your enterprise <br />
            <span className="text-[#3b82f6]">with precision.</span>
          </h2>

          <p className="text-slate-400 max-w-sm">
            Integrated platform for financial management and business insight.
          </p>
        </div>

        <p className="relative z-10 text-sm text-slate-500 italic">
          “Efficiency is doing things right; effectiveness is doing the right
          things.”
        </p>
      </div>

      {/* RIGHT PANEL */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
        <div className="w-full max-w-[400px]">
          <h3 className="text-3xl font-bold mb-2">Sign In</h3>
          <p className="text-slate-500 text-sm mb-8">
            Enter your credentials to access the system.
          </p>

          {error && (
            <div className="mb-6 flex gap-2 bg-red-50 border-l-4 border-red-500 p-3 text-xs text-red-800 rounded">
              <AlertCircle size={14} />
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <label className="text-xs font-semibold flex gap-2 mb-1">
                <User size={14} /> Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full h-11 px-4 rounded-lg border focus:ring-2 focus:ring-blue-500/30 outline-none"
                required
              />
            </div>

            <div>
              <label className="text-xs font-semibold flex gap-2 mb-1">
                <Lock size={14} /> Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-11 px-4 rounded-lg border focus:ring-2 focus:ring-blue-500/30 outline-none"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full h-12 bg-[#1d63ed] hover:bg-blue-700 text-white rounded-lg flex items-center justify-center gap-2 font-bold"
            >
              {loading ? "Verifying..." : "Access System"}
              <ChevronRight size={16} />
            </button>
          </form>

          <p className="text-[10px] text-slate-300 uppercase tracking-widest text-center mt-10">
            © 2026 ERP Systems International
          </p>
        </div>
      </div>
    </div>
  );
}
